import React from 'react';

import { data as paymentDataPropTypes } from './paymentPropTypes.js';

const ReceiptLink = ({ payment }) =>
    payment.receiptUrl ? (
        <div className="mtl">
            <a href={payment.receiptUrl}>Se kvittering</a>
        </div>
    ) : null;

ReceiptLink.propTypes = {
    payment: paymentDataPropTypes.isRequired,
};

export default ReceiptLink;



// WEBPACK FOOTER //
// ./safeTrade/receiptLink.jsx